import React, { useState, useMemo, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import DatePicker from "react-datepicker";
import format from "date-fns/format";
import { getServiceTypeDashboardApi } from "../../../services/DashboardService";
import { toast } from "react-toastify";
export default function ServiceTypeChart({ selectedServicecenter }) {
  const [data, setData] = useState([]);
  const [param, setParam] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });
  const getData = () => {
    getServiceTypeDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter,
      param
    )
      .then((res) => {
        setData(res?.data?.results||[]);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (selectedServicecenter) {
      getData();
    }
  }, [selectedServicecenter, param]);

  const series = useMemo(() => data?.map((v) => Number(v.billings_count)), [data]);
  const labels = useMemo(() => data?.map((v) => v.service_type_name), [data]);
  const options = {
    chart: {
      type: "pie",
      width: "100%",
    },
    labels:labels,
    colors: ["#7f0000", "#b71c1c", "#c62828", "#d32f2f", "#e53935", "#f44336"],
    dataLabels: {
      formatter: function (_, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
      style: {
        fontSize: "13px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#333",
      },
    },
    responsive: [
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 220,
          },
          dataLabels: {
            style: { fontSize: "11px" },
          },
          legend: {
            fontSize: "12px",
          },
        },
      },
    ],
  };

  return (
    <div className="card p-2 border-0 shadow-sm rounded-3 h-100">
      <div className="mb-2 px-1 d-flex justify-content-between align-items-center gap-1">
        <h5 className="mb-0">Service Type</h5>
        <div className="">
          <style>
            {`
                      .react-datepicker__input-container input {
                        font-size: 0.65rem !important;
                        height:31px !important;
                      }
                           .react-datepicker__close-icon::after {
                        font-size: 9px !important;
                        line-height: 9px !important;
                        width: 13px !important;
                        height: 9px !important;
                      }
                    `}
          </style>
          <DatePicker
            selectsRange
            startDate={param?.start_date ? new Date(param.start_date) : null}
            endDate={param?.end_date ? new Date(param.end_date) : null}
            onChange={(update) => {
              const [start, end] = update;
              setParam((prev) => ({
                ...prev,
                start_date: start ? format(start, "yyyy-MM-dd") : "",
                end_date: end ? format(end, "yyyy-MM-dd") : "",
              }));
            }}
            isClearable
            placeholderText="Select date range"
            className="form-control"
          />
        </div>
      </div>
      <div className="px-2">
        {series?.length > 0 ? (
          <ReactApexChart
            key={JSON.stringify(series) + JSON.stringify(labels)}
            options={options}
            series={series}
            type="pie"
            height={260}
          />
        ) : (
          <div className="text-center">
            <span className="my-3">No data found</span>
          </div>
        )}
      </div>
    </div>
  );
}
